import React, { useState } from 'react';
import { useMapStore } from '../store/useMapStore';
import './SearchBar.css';

interface SearchBarProps {
  onSearch?: (query: string) => void;
  placeholder?: string;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  placeholder = 'Search',
}) => {
  const [query, setQuery] = useState('');
  const { flyTo } = useMapStore();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (query.trim()) {
      onSearch?.(query);
      flyTo(-122.4194, 37.7749);
    }
  };

  return (
    <div id="top-toolbar" className="top-toolbar--disabled">
      <div className="tool-group">
        <button className="tool-btn" title="Place Marker (Coming soon)" disabled>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
            <circle cx="12" cy="10" r="3"></circle>
          </svg>
        </button>
        <button className="tool-btn" title="Draw Line (Coming soon)" disabled>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5.5 18.5l13-13"></path>
          </svg>
        </button>
      </div>
      <div className="search-container" id="location-search-container">
        <div className="search-input-wrapper">
          <input
            type="text"
            id="location-search"
            placeholder={placeholder}
            value={query}
            disabled
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSubmit(e);
              }
            }}
          />
        </div>
        <button className="search-button" onClick={handleSubmit} disabled>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <path d="m21 21-4.35-4.35"></path>
          </svg>
        </button>
      </div>
    </div>
  );
};
